import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { defaultOption: String };

    connect() {
        this.element.addEventListener("change", this.handleRedirect.bind(this));
    }

    handleRedirect(event) {
        const href = event.target.value;
        if (href) {
            window.location.href = href;
        }
    }
}